/**
 * 公共的方法
 * (公共弹窗、弱提示方法。。。。。)
 * **/
import {invokeApi} from './GLOBAL2'


/**
 *购买产品设置缓存
 * 参数说明
 * orderSource:订单来源=>0购物车,1请酸奶,2长期订购,3促销,4请酸奶兑换,5礼品卡促销,6限时特惠,7满减,11订单管家,12闪购,13门店支付,14团购,15单品直接买,16套装直接买,17酸奶库;
 * bindCode:绑定码,没有填''
 * deliverType:配送类型1正常配送，2包月，3包季，4包年，5自定义
 * deliverCount:配送次数
 * deliverPeriod:配送间隔
 * items:商品信息json => itemType(1促销,2套装,4单品),itemId(促销Id，套装Id，商品Id),quantity(数量);  例:{"itemType":4,"itemId":"3078372906554431580","quantity":6}
 * defindField:自定义字段，如果特殊情况有其他需要传送的信息，在这里传值，用json格式
 * response:响应函数
 * **/
export const setOrderCache = function(orderSource,bindCode,deliverType,deliverCount,deliverPeriod,items,defindField,response) {
    let params = {
        orderSource:orderSource,
        bindCode:bindCode,
        deliverType:deliverType,
        deliverCount:deliverCount,
        deliverPeriod:deliverPeriod,
        items:encodeURIComponent(JSON.stringify(items)),
        defineField:encodeURIComponent(JSON.stringify(defindField)),
    };
    invokeApi('order/setOrderCache',params,'post',Math.random(),function (res) {
        response(res)
    });
};

/**获取地址标签方法**/
export const setAddressTab = function(response){
    invokeApi('customerAddress/getAddressType',{},'post',Math.random(),function (res) {
        response(res);
    });
};
/**获取地址标签方法**/
export const setInitProvinceCityAreaList = function(call){
    invokeApi('customerAddress/getProvinceCityAreaByErp',{transportType:GetQueryString('transportType')||-1,isLongPeriodBuy:GetQueryString('isLongPeriodBuy')||0},'post',Math.random(),function (res) {
        call(res);
    });
};

export const getAddressKeyTab = function(obj,state){
    let name = state==''?'未分类':'';

    obj.forEach(function (key) {
        if(state == key.value){
            name = key.name;
        }
    });
    return name
};


/**
 * 设置cookie
 * isZeroTime是否为当天24点清缓存(默认为false)
 */
function setCookie(name,value,isZeroTime){
    let curDate = new Date();
    let Days = 360*24*60*60*1000;
    let curTamp = curDate.getTime();
    if(isZeroTime){
        //当前日期
        let curDay = curDate.toLocaleDateString();
        let curWeeHours = new Date(curDay).getTime() - 1;
        //当日已经过去的时间（毫秒）
        let passedTamp = curTamp - curWeeHours;
        Days = 24 * 60 * 60 * 1000 - passedTamp;
    }
    curDate.setTime(curTamp + Days);
    document.cookie = name + "="+ encodeURIComponent (value) + ";domain="+getWebDomain()+";path=/;expires=" + curDate.toGMTString();
};


/**
 * 获取cookie
 */
function getCookie(name){
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return decodeURIComponent(arr[2]);
    else
        return null;
};

function delCookie(name){
    var cval=getCookie(name);
    console.log('cval='+cval);
    var exp = new Date();
    exp.setTime(exp.getTime() - 360*24*60*60*1000);
    if(cval!=null){
        document.cookie = name + "="+ encodeURIComponent (cval) + ";domain="+getWebDomain()+";path=/;expires=" + exp.toGMTString();
        console.log('删除cookie='+name + "="+encodeURIComponent(cval)+";expires="+exp.toGMTString());
    }
}

/**
 * 获取网页URL参数
 */
function GetQueryString(name){
    let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    let u=window.location.search.substr(1);
    u= u.replace(/amp;/g,"");
    let r = u.match(reg);
    if(r!=null)return  decodeURIComponent(r[2]);
    return "";
}


/**
 * 获取网站一级域名
 * **/
function getWebDomain(){
    let host = document.domain;
    let domain = host.substring(host.indexOf('.')+1);
    return domain
}
/**
 * 获取平台标识
 * **/
function getPlatFrom(){
    let platId = '';

    switch (getWebDomain()){
        case 'lechun.cc':
            platId='lc';
            break;
        case 'meiriyuanqi.com':
            platId='';
            break;
        case 'xiaobuji.com':
            platId='xb';
    }
    return platId
}

/**
 * 格式化时间戳
 * @param 时间戳
 * @return 返回格式化后时间。
 */
function getFormatDate(timeStamp) {
    function add0(m) {
        return m < 10 ? '0' + m : m
    }
    //timeStamp 是整数，否则要parseInt转换
    var time = new Date(timeStamp);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}
function getFormatOnlyDate(timeStamp) {
    function add0(m) {
        return m < 10 ? '0' + m : m
    }
    //timeStamp 是整数，否则要parseInt转换
    var time = new Date(timeStamp);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    return y+'-'+add0(m)+'-'+add0(d);
}


export {getCookie,setCookie,delCookie,GetQueryString,getWebDomain,getFormatDate,getPlatFrom,getFormatOnlyDate}



// WEBPACK FOOTER //
// ./src/resource/js/common.js